import { InputProps } from "@chakra-ui/react";
import React from "react";

import { Container } from "./styles";

interface ITextProps extends InputProps {
  label: string;
}

const Text: React.FC<ITextProps> = (props) => {
    const { label } = props;
    return (
        <Container { ...props } active={ true }>
            { label }
        </Container>
    );
};

export default Text;
